import { CloseIcon } from '@ordr-as/icons'
import { ReactNode } from 'react'
import ReactTooltip from 'react-tooltip'

type DetailTemplateProps = {
    heading: string
    closeButtonTooltip: string
    onClose: () => void
    children: ReactNode
}

const DetailTemplate = (props: DetailTemplateProps) => {
    const { heading, closeButtonTooltip, onClose, children } = props

    return (
        <div className="h-full p-6 flex flex-col overflow-y-scroll">
            {/** Header **/}
            <div className="flex items-center mb-5">
                <div className="flex-1">
                    <h1>{heading}</h1>
                </div>

                <div
                    onClick={onClose}
                    className="p-2 rounded cursor-pointer hover:bg-purple-lightest"
                    data-tip
                    data-for="close-detail-template-tooltip"
                >
                    <CloseIcon height={20} width={20} />
                </div>
                <ReactTooltip
                    id="close-detail-template-tooltip"
                    arrowColor="transparent"
                    effect="solid"
                    padding="1px 4px"
                    className="text-bold !opacity-100"
                >
                    {closeButtonTooltip}
                </ReactTooltip>
            </div>
            <div>{children}</div>
        </div>
    )
}

export default DetailTemplate
